import qs from "qs";
import axios from "axios";

export class ConversationsClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = baseURL;
  }

  async getReport(query) {
    const queryString = qs.stringify(query, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/conversations/report${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }

  async getUnreadContactProject() {
    const replacedUrl = this.baseURL.replace("/api", "");
    const url = `${replacedUrl}/conversations/projects/badges`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getProjectConversationStats(params) {
    const response = await axios
      .get(`${process.env.HOST}/admin/conversations/count-by-projects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        },
        params: {
          projectIds: params.projectIds,
          dateFilter: params.dateFilter
        }
      })

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/conversations.js